var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[(_vm.ticketDeleted === true)?_c('div',{staticClass:"row"},[_c('h1',{staticClass:"col-12 mt-3 mb-3 pl-0 text-center text-lg"},[_vm._v(" "+_vm._s(_vm.$t('message.loadingErrors.ticketDeleted'))+" ")])]):(_vm.ticket)?_c('ticket-details-view',{attrs:{"public-ticket":_vm.ticket,"email":_vm.email}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }